import React from "react";
import Register from "./Content";
import AuthLayout from "../../../components/layout/AuthLayout";
import { getDomainConfig } from "../../../utils/DomainsHelper";


const SignupPage = () => {
  // Initialize directly from domain config to avoid empty-state flash (improves LCP)
  const domainConfig = getDomainConfig();

  return (
    <AuthLayout
      LeftComponent={Register}
      rightBgImage={domainConfig.banner}
    />
  );
};

export default SignupPage;